/* eslint-disable react/prop-types */
import React, { useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useFormPageHandler, useMergeState } from 'irmlib/hooks'
// import { XDivider, YDivider } from 'irmlib/styles'
import { MainRouteSubRoutePage } from '../../AppControl/RoutePage'
// import { TextField, CancelButton, SaveButton } from 'irmlib/components/FormControls'
import { Autocomplete, TextField, CancelButton, SaveButton } from '../../../irmlib/src/components/FormControls'
import TemplateFormat from './TemplateFormation'
import { translate } from 'irmlib/multilanguage'
import { setBusy, clearBusy, LocalToast, openGeneralDialog, closeGeneralDialog } from 'irmlib/containers'
import { ThemeButton, Label, OutlinedButton } from 'irmlib/components/Controls'
import { ContainedButton } from 'irmlib/components/Controls/Button'
import * as constants from 'irmlib/common/constants'
import * as gdeTransactions from '../../../services/firestore/gdeTransactions'
import * as routePaths from '../../../navigation/routePaths'
import { useHistory } from 'react-router-dom'
import * as regx from 'irmlib/components/FormControls/'
import { validateAndGetAccountLevel1, validateAndGetAccountLevel2, validateAndGetAccountLevel3 } from '../../../services/skpApi'
import { getUser } from '../../../redux/global'
import { TextareaAutosize, Typography } from '@material-ui/core'
import { successToast } from '../../../common/functions'
import { defaultDateFormat2, countryConfig } from '../../../common/constants'
import { useTranslation } from 'react-i18next'
import { CreateTemplateIntentContainer, CreateTemplateAccountsIntentContainer, XDivider, YDivider } from '../../../irmlib/src/styles'
import { Card, CardContent, Box } from '@mui/material'
// import styled from 'styled-components'
// import axios from 'axios'

const unknownError = 'Unknown Error.'
const defaultSelectOption = { value: constants.defaultSelect, label: constants.defaultSelect }
const CUSTOM = 'CUSTOM'
const NEW_FILE = 'New File'
const useStandardTemplate = 'useStandarrdTemplate'

let title = ''

const formTemplate = [
  {
    label: 'templates.country',
    fieldKey: 'country',
    defaultValue: constants.defaultSelect,
    isRequired: true
  },
  {
    label: 'Search.wms',
    fieldKey: 'wms',
    defaultValue: constants.defaultSelect,
    isRequired: true
  },
  {
    label: 'templates.accountLevelOne',
    fieldKey: 'accountLevel1',
    defaultValue: '',
    isRequired: true
  },
  {
    label: 'templates.accountLevelTwo',
    fieldKey: 'accountLevel2',
    defaultValue: '',
  },
  {
    label: 'templates.accountLevelThree',
    fieldKey: 'accountLevel3',
    defaultValue: '',
  },
  {
    label: 'templates.templateType',
    fieldKey: 'deType',
    defaultValue: constants.defaultSelect,
    isRequired: true,
  },
  {
    label: 'templates.templateName',
    fieldKey: 'templateName',
    defaultValue: constants.defaultSelect,
    isRequired: true,
  },
  {
    label: 'templates.templateName',
    fieldKey: 'templateName',
    isRequired: true,
    maxLength: 60,
    regx: regx.alphanumericRegex,
    regxError: regx.alphanumericRegexError,
  },
  {
    label: 'templates.skpinstance',
    fieldKey: 'skpinstance',
    // isRequired: true
  },
]

const VerticalDivider = () =>
  <YDivider height='20px' />

// const HorzintalDivider = styled.div`
//   display: block;
//   width: 50px;
//   background-color: red;
// `

const BottomPaddedButton = props =>
  <>
    <ThemeButton {...props} />
    <VerticalDivider />
  </>

// const CancelButtonPage = props =>
// <>
//   <CancelButton id={'createTemplate_button_cancel'} arrRefs={props.arrRefs} onClick={props.handleCancel} />
// </>

const Buttons = props =>
  <>
    <CancelButton id={'createTemplate_button_cancel'} arrRefs={props.arrRefs} onClick={props.handleCancel} />
    <XDivider width='10px' />
    {props?.showTable && <SaveButton id={'createTemplate_button_save'} disabled={Object.keys(props.validationErrors).length > 0} arrRefs={props.arrRefs} postService={props.handlePageSave} /> }
  </>

Buttons.propTypes = {
  arrRefs: PropTypes.array,
  handlePageSave: PropTypes.func,
  handleCancel: PropTypes.func,
  validationErrors: PropTypes.object
}

const getService = async () => {
  const getObject = {
  }
  return Promise.resolve(getObject)
}

// const SELECT_COUNTRY = 0
// const SELECT_WMS = 1
const SELECT_ACOUNT_LEVEL1 = 2
const SELECT_ACOUNT_LEVEL2 = 3
const SELECT_ACOUNT_LEVEL3 = 4
const SELECT_TEMPLATE_TYPE = 5
const SELECT_TEMPLATE_NAME = 6
const FIELD_CUSTOM_TEMPLATE_NAME = 7
const SKP_SYSTEM = 'SKP'
// const ONEIL_SYSTEM = 'ONEIL'
// const SKP_INSTANCE = 8


const initialSate = {
  showTable: false,
  countries: [],
  templates: [],
  templatesForSelect: [],
  workerDetails: [],
  wmsList: [],
  templateTypeList: [],
  selectedTemplateValues: [],
  selectedWms: '',
  selectedTemplate: '',
  disircts: [],
  skpInstance: [],
  WMSForAC: null,
  WMSSystem: SKP_SYSTEM,
  validationErrors: {},
  templateInstructions: '',
  changeTemplateInstructions: '',
  existingTemplateInstructions: '',
  showForm: false,
  errorMsg: '',
  country: '',
  resetBtn: false,
  countryCode: '',
  districtId: '',
  skpEncoding: {}
}

const CreateTemplate = () => {
  const { workerId: customerId, email: customerEmail = '' } = getUser()
  const refLocalBusyCursor = useRef(null)
  const [arrRefs, data] = useFormPageHandler({ 
    formTemplate, 
    service: getService, 
    busyOverride: refLocalBusyCursor,
  })
  const [state, setState, getState] = useMergeState(initialSate)
  const tableRef = useRef(null)
  const refLocalToast = useRef(null)
  const history = useHistory()
  const previousCustomerValue = useRef()
  const cachedValues = useRef({})
  // const { countryCode, district, workerId } = getUser()
  const { workerId } = getUser()
  const { t } = useTranslation()

  const ButtonsForDialogBox = props =>
    <>
      <BottomPaddedButton color='primary' variant='outlined' onClick={closeGeneralDialog}>buttons.cancel</BottomPaddedButton>
      <SaveButton arrRefs={props.arrRefs} postService={props.postService} saveLabel='buttons.save' />
    </>

  ButtonsForDialogBox.propTypes = {
    arrRefs: PropTypes.array,
    postService: PropTypes.func
  }

  const ContentForDialogBox = (props) =>
    <>
      <Label>messages.saveNewTemplateMessage</Label>
      <VerticalDivider />
      <TextField
        data={data}
        fieldTemplate={formTemplate[FIELD_CUSTOM_TEMPLATE_NAME]}
        ref={arrRefs[FIELD_CUSTOM_TEMPLATE_NAME]}
        noTranslateStartString
        startString={props.namePrefix()}
        inputProps={{ maxLength: (60 - props.namePrefix().length) }}
      />
    </>

  ContentForDialogBox.propTypes = {
    namePrefix: PropTypes.func
  }
  
  useEffect(() => {
    getCountries()
    getSkpInstance(workerId)
  }, [])

  const getCountries = async () => {
    const collection = await gdeTransactions.getCountries()
    const [, , , , skpEncoding] = await gdeTransactions.getGdeConfig()
    const countryList = []
    collection.forEach((doc) => {
      countryList.push({ value: doc.id, label: `${doc.id}-${doc.data().countryName}`, wms: doc?.data()?.wms })
    })
    const user = getUser()
    setState({ skpEncoding: skpEncoding, countries: countryList, country: user?.userRolesObj?.gdeCountry })
    // arrRefs[SELECT_COUNTRY].current.setValue(user.countryCode)
    // arrRefs[SELECT_ACOUNT_LEVEL1].current.setDisabled(true)
    // arrRefs[SELECT_ACOUNT_LEVEL2].current.setDisabled(true)
    // arrRefs[SELECT_ACOUNT_LEVEL3].current.setDisabled(true)
    arrRefs[SELECT_ACOUNT_LEVEL1].current.focus()
  }

  // const getWms = async (countryCode) => {
  //   const wmsSystems = []
  //   let isSkpDisabled = true
  //   const wmsForList = [defaultSelectOption]
  //   const collection = await gdeTransactions.getWmsSystemFroCountry(countryCode)
  //   collection.forEach((doc) => {
  //     const wms = doc.data().wms
  //     if (wms !== undefined && wms !== null && !wmsSystems.includes(wms) && wms === 'SKP') {
  //       if (wms === SKP_SYSTEM) {
  //         isSkpDisabled = false
  //       }
  //       wmsSystems.push(wms)
  //       wmsForList.push({ value: wms, label: wms })
  //     }
  //   })

  //   arrRefs[SKP_INSTANCE].current.clear()
   
  //   if (wmsSystems.length === 1) {
  //     setState({ selectedWms: wmsSystems[0], wmsList: wmsForList, WMSSystem: wmsSystems[0] })
  //   } else {
  //     setState({ wmsList: wmsForList })
  //   }

  //   return isSkpDisabled
  // }

  const getSkpInstance = async (workerId) => {
    const workerDetailsGde = await gdeTransactions.getWorkerRoleGde(workerId)
    const workerDetails = await gdeTransactions.getWorkerDetails(workerId)
    setState({ countryCode: workerDetailsGde?.gdeCountryCode || workerDetails?.countryCode, country: workerDetailsGde?.gdeCountry || workerDetails?.country, districtId: workerDetailsGde?.district[0] || workerDetails?.gdeDistrict || workerDetails?.district })
    const doc = await gdeTransactions.getCountrySkpInstance(workerDetailsGde?.gdeCountry || workerDetails?.country)
    doc?.docs?.forEach((doc) => {
      setState({ skpInstance: doc?.data()?.skpInstance, wmsInstance: doc?.data()?.skpInstance })
    })
    doc?.docs?.forEach((doc) => {
      if (doc.data()?.wms?.skp !== undefined || doc.data()?.wms?.skp !== 'undefined') {
        setState({ wmsForCountry: 'SKP' })
      }
    })
    await getTemplateTypes(getState()?.wmsForCountry)
    // const workerDetailsGde = await gdeTransactions.getWorkerRoleGde(workerId)
    // setState({ countryCode: workerDetailsGde?.gdeCountryCode })
    // const checkSkpInstance = countryConfig.find(entry => entry.countryCode === workerDetailsGde?.gdeCountryCode)
    // if (checkSkpInstance) {
    //   setState({ skpInstance: 'AMER' })
    // } else {
    //   setState({ skpInstance: 'EURO' })
    // }
  }



  // const getTemplateTypesAfter = async collection => {
  //   const templateTypes = [defaultSelectOption]
  //   const standardTemplates = {}
  //   collection.forEach((doc) => {
  //     templateTypes.push({ value: doc.data().dataEntryType, label: doc.data().dataEntryType })
  //     standardTemplates[doc.data().dataEntryType] = doc.data()
  //   })
  //   setState({ templateTypeList: templateTypes, standardTemplates: standardTemplates })
  // }

  const getTemplateTypesForWms = async wms => {
    const key = `getTemplateTypesForWms-${wms}`
    if (cachedValues.current[key]) {
      return cachedValues.current[key]
    } else {
      const collection = await gdeTransactions.getTemplateTypesForWms(wms)
      cachedValues.current[key] = collection
      return collection
    }
  }

  const getTemplateTypes = async (wms) => {
    const collection = await getTemplateTypesForWms(wms)
    // getTemplateTypesAfter(collection)
    const templateTypes = [defaultSelectOption]
    const standardTemplates = {}
    collection.forEach((doc) => {
      if (doc.data()?.assetType !== 'BOX TRANSMITTAL') {
        templateTypes.push({ value: doc.data().dataEntryType, label: doc.data().dataEntryType })
        standardTemplates[doc.data().dataEntryType] = doc.data()
      }
    })
    setState({ templateTypeList: templateTypes, standardTemplates: standardTemplates })
  }

  const getTemplatesForTemplateType = async (templateType, wms) => {
    const accLevel1 = arrRefs[SELECT_ACOUNT_LEVEL1].current.getValue()
    if (cachedValues.current.accLevel1 === accLevel1 && cachedValues.current.templateType === templateType) {
      return
    }
    cachedValues.current.accLevel1 = accLevel1
    cachedValues.current.templateType = templateType
    const collection = await gdeTransactions.getTemplates(templateType, accLevel1)
    const useStandardTemplateOption = { value: useStandardTemplate, label: translate('templates.useStandardTemplate') }
    const templateList = [defaultSelectOption, useStandardTemplateOption]
    const templateDetailsList = {}
    collection.forEach((doc) => {
      templateList.push({ value: doc.id, label: doc.id })
      templateDetailsList[doc.id] = doc
    })
    setState({ templates: templateDetailsList, templatesForSelect: templateList, selectedTemplate: '' })
  }

  // backend data conversion for template types
  state.templateTypeList.forEach((element, index) => {
    if (element.label !== '--Select--') {
      element.label = t(`templateTypeObj.${element.value}`)
    }
  })

  // const onChangeCountry = async (value) => {
  //   setBusy()
  //   if (value !== undefined && value !== constants.defaultSelect) {
  //     const selectedcountry = getState().countries.find(country => country.value === value)
      
  //     setState({ WMSForAC: selectedcountry.wms, countryCode: value })
  //     const isSkpDisabled = await getWms(value)
  
  //     arrRefs[SKP_INSTANCE].current.setDisabled(isSkpDisabled)
  //     getState().countries.find(country => country.value === value)
  //   }
  //   arrRefs[SELECT_ACOUNT_LEVEL1].current.clear()
  //   arrRefs[SELECT_ACOUNT_LEVEL2].current.clear()
  //   arrRefs[SELECT_ACOUNT_LEVEL3].current.clear()
  //   arrRefs[SELECT_TEMPLATE_TYPE].current.clear()
  //   // arrRefs[SKP_INSTANCE].current.clear()
  //   // await getTemplateTypes('')
  //   arrRefs[SELECT_TEMPLATE_NAME].current.clear()
  //   clearBusy()
  // }

  // const onChangeCustomer = (e) => {
  //   const value = e?.target?.value
  //   if (e.keyCode === 13 && value !== '') {
  //     validateAccountLevel1(value)
  //   }
  // }

  // const onBlurCustomer = (e) => {
  //   e?.preventDefault()
  //   arrRefs[SELECT_ACOUNT_LEVEL2].current.setDisabled(true)
  //   arrRefs[SELECT_ACOUNT_LEVEL3].current.setDisabled(true)
  //   validateAccountLevel1(e?.target?.value)
  // }

  const validateAccountLevel1 = async value => {
    const moveToNextField = () => {
      arrRefs[SELECT_ACOUNT_LEVEL1].current.clearErrorMsg()
      arrRefs[SELECT_ACOUNT_LEVEL1].current.setDisabled(true)
      arrRefs[SELECT_ACOUNT_LEVEL2].current.setDisabled(true)
      arrRefs[SELECT_ACOUNT_LEVEL3].current.setDisabled(true)
      arrRefs[SELECT_TEMPLATE_TYPE].current.setValue(NEW_FILE)
      // arrRefs[SELECT_TEMPLATE_TYPE].current.focus()
    }

  
    if (value === '') {
      arrRefs[SELECT_ACOUNT_LEVEL1].current.setErrorMsg('Required', true)
      arrRefs[SELECT_ACOUNT_LEVEL2].current.clear()
      arrRefs[SELECT_ACOUNT_LEVEL3].current.clear()
      arrRefs[SELECT_ACOUNT_LEVEL2].current.setDisabled(true)
      arrRefs[SELECT_ACOUNT_LEVEL3].current.setDisabled(true)
      return
    }

    setBusy()
    const errors = getState().validationErrors
    try {
      if (state.WMSSystem === SKP_SYSTEM) {
        previousCustomerValue.current = value
        const result = await Promise.all([
          validateAndGetAccountLevel1(getState()?.skpInstance, value),
          // getTemplateTypesForWms(state.WMSSystem)
        ])
        if (!result[0] || (!result[0].success && !result[0].error)) {
          arrRefs[SELECT_ACOUNT_LEVEL1].current.setErrorMsg(unknownError, true)
          errors[SELECT_ACOUNT_LEVEL1] = unknownError
          setState({ validationErrors: errors, errorMsg: unknownError })
        } else if (result[0].error) {
          // arrRefs[SELECT_ACOUNT_LEVEL1].current.setErrorMsg(result[0].error, true)
          errors[SELECT_ACOUNT_LEVEL1] = result[0].error
          setState({ validationErrors: errors, errorMsg: result[0].error })
        } else {
          delete errors[SELECT_ACOUNT_LEVEL1]
          setState({ validationErrors: errors, showForm: true, errorMsg: '', resetBtn: true })
          // getTemplateTypesAfter(result[1])
          moveToNextField()
        }
      } else {
        moveToNextField()
      }
    } catch (ex) {
      arrRefs[SELECT_ACOUNT_LEVEL1].current.setErrorMsg(`${unknownError} - ${ex}`, true)
      errors[SELECT_ACOUNT_LEVEL1] = `${unknownError} - ${ex}`
      setState({ validationErrors: errors })
    }
    clearBusy()
  }

  // const onChangeDivision = (e) => {
  //   const value = e?.target?.value
  //   if (e.keyCode === 13) {
  //     validateAccountLevel2(value)
  //   }
  // }

  // const onBlurDivision = (e) => {
  //   arrRefs[SELECT_ACOUNT_LEVEL3].current.setDisabled(true)
  //   e?.preventDefault()
  //   validateAccountLevel2(e?.target?.value)
  // }

  const validateAccountLevel2 = async value => {
    const moveToNextField = () => {
      arrRefs[SELECT_ACOUNT_LEVEL2].current.clearErrorMsg()
      arrRefs[SELECT_ACOUNT_LEVEL1].current.setDisabled(true)
      arrRefs[SELECT_ACOUNT_LEVEL2].current.setDisabled(true)
      arrRefs[SELECT_ACOUNT_LEVEL3].current.setDisabled(true)
      arrRefs[SELECT_TEMPLATE_TYPE].current.setValue(NEW_FILE)
      // arrRefs[SELECT_TEMPLATE_TYPE].current.focus()
    }
    if (arrRefs[SELECT_ACOUNT_LEVEL1].current.getValue() !== '') {
      setBusy()
      const errors = getState().validationErrors
      try {
        if (state.WMSSystem === SKP_SYSTEM) {
          const result = await Promise.all([validateAndGetAccountLevel2(getState()?.skpInstance, arrRefs[SELECT_ACOUNT_LEVEL1].current.getValue(), value)])
          if (!result[0] || (!result[0].success && !result[0].error)) {
            arrRefs[SELECT_ACOUNT_LEVEL2].current.setErrorMsg(unknownError, true)
            errors[SELECT_ACOUNT_LEVEL2] = unknownError
            setState({ validationErrors: errors, errorMsg: unknownError })
          } else if (result[0].error) {
            // arrRefs[SELECT_ACOUNT_LEVEL2].current.setErrorMsg(result[0].error, true)
            errors[SELECT_ACOUNT_LEVEL2] = result[0].error
            setState({ validationErrors: errors, errorMsg: result[0].error })
          } else {
            delete errors[SELECT_ACOUNT_LEVEL2]
            // getTemplateTypesAfter(result[1])
            setState({ validationErrors: errors, showForm: true, errorMsg: '', resetBtn: true })
            moveToNextField()
          }
        } else {
          moveToNextField()
        }
      } catch (ex) {
        arrRefs[SELECT_ACOUNT_LEVEL2].current.setErrorMsg(`${unknownError}: ${ex}`, true)
        errors[SELECT_ACOUNT_LEVEL2] = `${unknownError}: ${ex}`
        setState({ validationErrors: errors })
      }
      clearBusy()
    } else {
      arrRefs[SELECT_ACOUNT_LEVEL2].current.setErrorMsg('Account Level 1/ Customer Required', true)
    }
  }

  const validateAccountLevel3 = async value => {
    const moveToNextField = () => {
      arrRefs[SELECT_ACOUNT_LEVEL3].current.clearErrorMsg()
      arrRefs[SELECT_ACOUNT_LEVEL1].current.setDisabled(true)
      arrRefs[SELECT_ACOUNT_LEVEL2].current.setDisabled(true)
      arrRefs[SELECT_ACOUNT_LEVEL3].current.setDisabled(true)
      arrRefs[SELECT_TEMPLATE_TYPE].current.setValue(NEW_FILE)
      // arrRefs[SELECT_TEMPLATE_TYPE].current.focus()
    }
    if (arrRefs[SELECT_ACOUNT_LEVEL1].current.getValue() !== '') {
      setBusy()
      const errors = getState().validationErrors
      try {
        if (state.WMSSystem === SKP_SYSTEM) {
          const result = await Promise.all([validateAndGetAccountLevel3(getState()?.skpInstance, arrRefs[SELECT_ACOUNT_LEVEL1].current.getValue(), arrRefs[SELECT_ACOUNT_LEVEL2].current.getValue(), value)])
          if (!result[0] || (!result[0].success && !result[0].error)) {
            setState({ errorMsg: unknownError })
            arrRefs[SELECT_ACOUNT_LEVEL3].current.setErrorMsg(unknownError, true)
            errors[SELECT_ACOUNT_LEVEL3] = unknownError
            setState({ validationErrors: errors })
          } else if (result[0].error) {
            // arrRefs[SELECT_ACOUNT_LEVEL3].current.setErrorMsg(result[0].error, true)
            errors[SELECT_ACOUNT_LEVEL3] = result[0].error
            setState({ validationErrors: errors, errorMsg: result[0].error })
          } else {
            delete errors[SELECT_ACOUNT_LEVEL3]
            setState({ validationErrors: errors, showForm: true, errorMsg: '', resetBtn: true })
            // getTemplateTypesAfter(result[1])
            moveToNextField()
          }
        } else {
          arrRefs[SELECT_ACOUNT_LEVEL3].current.clearErrorMsg()
          arrRefs[SELECT_TEMPLATE_TYPE].current?.focus()
        }
      } catch (ex) {
        arrRefs[SELECT_ACOUNT_LEVEL3].current.setErrorMsg(`${unknownError}-${ex}`, true)
        errors[SELECT_ACOUNT_LEVEL3] = `${unknownError}-${ex}`
        setState({ validationErrors: errors })
      }
      clearBusy()
    } else {
      arrRefs[SELECT_ACOUNT_LEVEL3].current.setErrorMsg('Account Level 1/ Customer is Required', true)
    }
  }

  // const onChangeDepartment = (e) => {
  //   const value = e?.target?.value
  //   if (e.keyCode === 13) {
  //     if (value) {
  //       validateAccountLevel3(value)
  //     } else {
  //       arrRefs[SELECT_TEMPLATE_TYPE].current?.focus()
  //     }
  //   }
  // }

  // const onBlurDepartment = (e) => {
  //   e?.preventDefault()
  //   validateAccountLevel3(e?.target?.value)
  // }

  // const onChangeWms = (value) => {
  //   if (value !== undefined) {
  //     setState({ selectedWms: value, selectedTemplate: '', WMSSystem: value })
  //   } else {
  //     setState({ WMSSystem: SKP_SYSTEM })
  //   }
  // }

  const onChangeTemplateType = (value) => {
    if (value !== undefined || value !== null || value === constants.defaultSelect) {
      getTemplatesForTemplateType(value, getState().selectedWms)
    }
    arrRefs[SELECT_TEMPLATE_NAME].current.setValue(constants.defaultSelect)
  }

  const onChangeTemplate = (value) => {
    if (value === undefined || value === constants.defaultSelect || value === null) {
      setState({ showTable: false })
    } else {
      if (value === useStandardTemplate) {
        title = getState().standardTemplates[arrRefs[SELECT_TEMPLATE_TYPE].current.getValue()].templateName
      } else {
        title = value
      }
      setState({ showTable: true, selectedTemplate: value })
    }
  }

  const getTemplateFields = async () => {
    let fields
    if (getState().selectedTemplate === useStandardTemplate) {
      fields = getState().standardTemplates[arrRefs[SELECT_TEMPLATE_TYPE].current.getValue()].templateFields
      try {
        setState({ existingTemplateInstructions: getState().standardTemplates[arrRefs[SELECT_TEMPLATE_TYPE].current.getValue()].templateInstructions })
      } catch {
        // console.log('no instructions')
      }
    } else {
      fields = getState().templates[getState().selectedTemplate].data().templateFields
      try {
        setState({ existingTemplateInstructions: getState().templates[getState().selectedTemplate].data().templateInstructions })
      } catch {
        // console.log('no instructions')
      }
    }
    const arrayFields = Object.keys(fields).map((key) => {
      const data = fields[key]
      data.name = key
      return data
    })
    // arrRefs[SELECT_ACOUNT_LEVEL1].current.setDisabled(true)
    arrayFields.sort((a, b) => (a.customOrder > b.customOrder) ? 1 : ((b.customOrder > a.customOrder) ? -1 : 0))
    // defaulting date
    const checkCountry = countryConfig.find(entry => entry.countryCode === getState()?.countryCode)
    arrayFields.forEach((field) => {
      if (field?.dataType === 'Date') {
        if (checkCountry) {
          field.customFormat = checkCountry.dateFormat
        } else {
          field.customFormat = defaultDateFormat2
        }
      }
    })
    return Promise.resolve(arrayFields)
  }

  const saveTemplateValues = (values) => {
    const selectedTemplateValues = JSON.stringify(values)
    setState({ selectedTemplateValues: selectedTemplateValues })
  }

  const handleAdditionalFieldPopUp = () => {
    openGeneralDialog({
      title: t('options.aaditionFieldWarning'),
      message: t('options.aaditionFieldMessage'),
      noTranslate: true,
      noTranslateTitle: true,
      buttons: <ButtonsForAdditionalFieldDialog />,
      closeX: true
    })
  }

  const ButtonsForAdditionalFieldDialog = () =>
    <>
      <ContainedButton onClick={closeGeneralDialog} >buttons.Ok</ContainedButton>
    </>

  const checkAdditionalFieldForStandardTemplate = () => {
    if (getState().selectedTemplate === useStandardTemplate || arrRefs[SELECT_TEMPLATE_NAME].current.getValue() === useStandardTemplate) {
      let noOfFieldsInOriginalTemplate = 0
      let noOfFieldsInModifiedTemplate = 0
      const intialTemplateValues = JSON.parse(getState().selectedTemplateValues)
      const templateValuesFromtable = tableRef.current.dataManager.data

      templateValuesFromtable.forEach((data, index) => {
        if (data.tableData) {
          if (data.tableData.checked) {
            noOfFieldsInModifiedTemplate++
          }
        }
        return noOfFieldsInModifiedTemplate
      })

      intialTemplateValues.forEach((data, index) => {
        if (data.tableData) {
          if (data.tableData.checked) {
            noOfFieldsInOriginalTemplate++
          }
        }
        return noOfFieldsInOriginalTemplate
      })

      if (noOfFieldsInOriginalTemplate >= noOfFieldsInModifiedTemplate) {
        handleAdditionalFieldPopUp()
        return false
      } else {
        return true
      }
    } else {
      return true
    }
  } 

  const handlePageSave = async postObject => {
    const result = checkAdditionalFieldForStandardTemplate()
    if (result) {
      openGeneralDialog({
        title: t('forms.saveNewTemplate'),
        noTranslateTitle: true,
        message: <ContentForDialogBox namePrefix={getTemplateNamePrefix}/>,
        buttons: <ButtonsForDialogBox arrRefs={arrRefs} postService={postService} />,
        closeX: true
      })
    }
  }

  
  const ButtonsForCancelDialogBox = () =>
    <>
      <OutlinedButton id={'createTemplate_dialogBoxButton_no'} onClick={closeGeneralDialog} >buttons.no</OutlinedButton>
      <ContainedButton id={'createTemplate_dialogBoxButton_yes'} onClick={handleCancelButtonOnClick} >buttons.yes</ContainedButton>
    </>

  const handleCancelButtonOnClick = () => {
    closeGeneralDialog()
    history.push(routePaths.root)
  }

  const handleCancel = () => {
    openGeneralDialog({
      title: t('options.cancelTemplateTitle'),
      message: t('options.cancelJobMessage'),
      noTranslateTitle: true,
      noTranslateMessage: true,
      buttons: <ButtonsForCancelDialogBox />,
      closeX: true
    })
  }

  const ContentforInstructionsBox = () => {
    return (
      <TextareaAutosize
        aria-label="empty textarea"
        placeholder= {t('forms.enterInstructions')}
        label= {t('forms.enterInstructions')}
        style={{ width: 500, height: 50 }}
        onBlur={(e) => setState({ templateInstructions: e.target.value })}
        defaultValue={ getState().existingTemplateInstructions || getState().changeTemplateInstructions }
      />
    )
  } 
  
  const ButtonsforInstructionBox = () => {
    return (
      <>
        <BottomPaddedButton color= 'primary' variant= 'outlined' onClick={closeGeneralDialog}>buttons.cancel</BottomPaddedButton>
        <BottomPaddedButton color= 'primary' variant= 'contained' onClick ={handleInstructionsSave}>buttons.save</BottomPaddedButton>
      </>
    )
  }
  
  const handleInstructionsSave = () => {
    setState({ changeTemplateInstructions: getState().templateInstructions || getState().existingTemplateInstructions })
    setTimeout(successToast({ message: t('toast.templateInstructionsSaved') }, 50000))
    closeGeneralDialog()
  }

  const handleAddInst = () => {
    openGeneralDialog({ 
      title: t('forms.enterInstructions'),
      noTranslateTitle: true,
      message: <ContentforInstructionsBox />,
      buttons: <ButtonsforInstructionBox />
    })
  }


  const getTemplateNamePrefix = () => {
    const selectFieldCountry = getState()?.countryCode
    const selectFieldCustomer = arrRefs[SELECT_ACOUNT_LEVEL1].current.getValue()
    const selectFieldDivision = arrRefs[SELECT_ACOUNT_LEVEL2].current.getValue()
    const selectFieldDepartment = arrRefs[SELECT_ACOUNT_LEVEL3].current.getValue()
    
    const prefix = `${selectFieldCountry.toUpperCase()}-${selectFieldCustomer.toUpperCase()}-${selectFieldDivision ? `${selectFieldDivision.toUpperCase()}-` : 'MASTER-'}${selectFieldDepartment ? `${selectFieldDepartment.toUpperCase()}-` : 'MASTER-'}`
    return prefix
  }

  const postService = async postObject => {
    const customTemplateName = (getTemplateNamePrefix() + postObject.templateName).toUpperCase()
    if (Object.keys(getState().templates).includes(customTemplateName)) {
      arrRefs[FIELD_CUSTOM_TEMPLATE_NAME].current.setErrorMsg('templates.templateNameErrorMessage')
    } else {
      closeGeneralDialog()
      const fields = {}
      const arrPost = tableRef.current.dataManager.data
      let costomOrder = 1
      arrPost.forEach(r => {
        if (r.tableData.checked) {
          delete r.rowSelected
          delete r.tableData
          const fieldName = r.name
          delete r.name
          delete r.isRequiredChanged
          r.customOrder = costomOrder
          costomOrder++
          fields[fieldName] = r
        }
      })
      const templateData = {
        countryCode: getState()?.countryCode,
        wmsCode: getState().WMSSystem,
        accountLevel1: postObject.accountLevel1.toUpperCase(),
        accountLevel2: postObject.accountLevel2.toUpperCase(),
        accountLevel3: postObject.accountLevel3.toUpperCase(),
        dataEntryType: postObject.deType,
        skpinstance: getState()?.skpInstance,
        templateType: CUSTOM,
        standardTemplateName: getState().standardTemplates[arrRefs[SELECT_TEMPLATE_TYPE].current.getValue()].templateName,
        templateName: customTemplateName,
        templateFields: fields,
        createdBy: customerEmail || customerId,
        createdTs: new Date(),
        lastUsed: new Date(),
        templateInstructions: getState().changeTemplateInstructions || getState().existingTemplateInstructions || ''
      }
  
      gdeTransactions.createTemplate(templateData)
        .then(() => {
          refLocalToast.current?.successToastOn({
            message: t('toast.templateCreatedSuccessfully',
              { templateName: customTemplateName }),
            title: t('toast.templateCreationTitle'),
            noTranslateMessage: true,
            noTranslateTitle: true
          })
          arrRefs[SELECT_ACOUNT_LEVEL1].current.clear()
          arrRefs[SELECT_ACOUNT_LEVEL2].current.clear()
          arrRefs[SELECT_ACOUNT_LEVEL3].current.clear()
          arrRefs[SELECT_TEMPLATE_TYPE].current.clear()
          arrRefs[SELECT_TEMPLATE_NAME].current.clear()
          setState({ showForm: false, resetBtn: false })
        })
        .catch((e) => {
          // console.log('Create template Failed')
          // console.log(e)
        })
  
      return Promise.resolve()
    }
  }

  // const selectskpinstance = [
  //   { value: 'AMER', label: 'AMER' },
  //   { value: 'EURO', label: 'EURO' },
  // ]

  // const onChangeskpinstance = () => {
  //   arrRefs[SELECT_ACOUNT_LEVEL1].current.clearErrorMsg()
  //   arrRefs[SELECT_ACOUNT_LEVEL1].current.setDisabled(false)
  // }
  const handleValidate = () => {
    if (arrRefs[SELECT_ACOUNT_LEVEL1].current.getValue() !== '' && arrRefs[SELECT_ACOUNT_LEVEL3].current.getValue() !== '') {
      validateAccountLevel3(arrRefs[SELECT_ACOUNT_LEVEL3].current.getValue())
    } else if (arrRefs[SELECT_ACOUNT_LEVEL1].current.getValue() !== '' && arrRefs[SELECT_ACOUNT_LEVEL2].current.getValue() !== '' && arrRefs[SELECT_ACOUNT_LEVEL3].current.getValue() === '') {
      validateAccountLevel2(arrRefs[SELECT_ACOUNT_LEVEL2].current.getValue())
    } else if (arrRefs[SELECT_ACOUNT_LEVEL1].current.getValue() !== '' && arrRefs[SELECT_ACOUNT_LEVEL2].current.getValue() === '' && arrRefs[SELECT_ACOUNT_LEVEL3].current.getValue() === '') {
      validateAccountLevel1(arrRefs[SELECT_ACOUNT_LEVEL1].current.getValue())
    }
  }


  // const clearErrorMessage = () => {
  //   setState({ clearErrorMsg: '' })
  // }


  // const handleValidate1 = async() => {
  //   const accLvl1 = arrRefs[SELECT_ACOUNT_LEVEL1].current.getValue().toUpperCase()
  //   const accLvl2 = arrRefs[SELECT_ACOUNT_LEVEL2].current.getValue().toUpperCase()
  //   let accLvl3 = arrRefs[SELECT_ACOUNT_LEVEL3].current.getValue().toUpperCase()
  //   if(accLvl3.includes('/')) {
  //     const newAcclvl3 = accLvl3.replace(/\//g, '|')
  //     accLvl3 = newAcclvl3
  //   }
  //   try {
  //     const docId = `${accLvl1}|${accLvl2}|${accLvl3}`
  //     // const docId = 'CZ099|9902|990201'
  //     // const docId = `${arrRefs[SELECT_ACOUNT_LEVEL1].current.getValue()}||`
  //     const response = await axios.get(`https://us-central1-irm-eap-edp-mobile-sandbox.cloudfunctions.net/grpGde-AccountDataAPI?docId=${docId}`)
  //     if (response.data?.data) {
  //       setState({ accountLevel1Description: response.data?.data?.customerName, showForm: true, resetBtn: true })
  //       const types = await getTemplateTypesForWms(state.WMSSystem)
  //       getTemplateTypesAfter(types)
  //       arrRefs[SELECT_ACOUNT_LEVEL3].current.setDisabled(true)
  //       arrRefs[SELECT_ACOUNT_LEVEL2].current.setDisabled(true)
  //       arrRefs[SELECT_ACOUNT_LEVEL1].current.setDisabled(true)
  //       arrRefs[SELECT_TEMPLATE_TYPE].current.focus()
  //     } else {
  //       setState({ errorMsg: 'Please enter a valid account level details.' })
  //     }
  //     setData(response.data)
  //   } catch (error) {
  //     console.error(error)
  //   }
  // }

  const handleReset = () => {
    setState({ showForm: false, showTable: false, resetBtn: false })
    arrRefs[SELECT_ACOUNT_LEVEL1].current.clear()
    arrRefs[SELECT_ACOUNT_LEVEL2].current.clear()
    arrRefs[SELECT_ACOUNT_LEVEL3].current.clear()
    arrRefs[SELECT_ACOUNT_LEVEL1].current.setDisabled(false)
    arrRefs[SELECT_ACOUNT_LEVEL2].current.setDisabled(false)
    arrRefs[SELECT_ACOUNT_LEVEL3].current.setDisabled(false)
    arrRefs[SELECT_ACOUNT_LEVEL1].current.focus()
  }

  return (
    <>
      <MainRouteSubRoutePage
        mainTitle='routeTitles.templateManagement'
        subTitle='routeTitles.createNewTemplate'
        buttons={getState()?.showForm && <Buttons arrRefs={arrRefs} handlePageSave={handlePageSave} handleCancel={handleCancel} showTable={getState()?.showTable} validationErrors={getState().validationErrors} />}
        createJobParams={[getState()?.countryCode, getState()?.districtId, getState()?.skpInstance, getState()?.country]} createPage={true}
      // style={{ width: '70vw' }}
      >
        {/* <Modal 
        open={true}
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}> */}
        {/* <Typography variant='h3'>{countryCode-getState()?.country}{district}{getState()?.skpInstance}</Typography> */}
        {/* <h3>us-United States of America</h3> <h3>A-ATLANTA</h3> <h3>AMER</h3> */}
        <Card style={{ width: '70vw', margin: '1rem' }}>
          <CardContent>
            {/* <FlexByRow> */}
            <LocalToast ref={refLocalToast} />
            <CreateTemplateAccountsIntentContainer>
              <TextField
                id={'createJob_accountLevel'}
                // onKeyDown={clearErrorMessage}
                // onKeyDown={(e) => onChangeCustomer(e)}
                // onBlur={(e) => onBlurCustomer(e)}
                data={data}
                fieldTemplate={formTemplate[SELECT_ACOUNT_LEVEL1]}
                ref={arrRefs[SELECT_ACOUNT_LEVEL1]}
                value={arrRefs[SELECT_ACOUNT_LEVEL1]}
              // style={{ width: '30px' }}
              />
              <TextField
                id={'createJob_accountLeve2'}
                // onKeyDown={() => clearErrorMessage()}
                // onKeyDown={(e) => onChangeDivision(e)}
                // onBlur={(e) => onBlurDivision(e)}
                data={data}
                fieldTemplate={formTemplate[SELECT_ACOUNT_LEVEL2]}
                ref={arrRefs[SELECT_ACOUNT_LEVEL2]}
              />
              <TextField
                id={'createJob_department'}
                // onKeyDown={() => clearErrorMessage()}
                // onKeyDown={(e) => onChangeDepartment(e)}
                // onBlur={(e) => onBlurDepartment(e)}
                data={data}
                fieldTemplate={formTemplate[SELECT_ACOUNT_LEVEL3]}
                ref={arrRefs[SELECT_ACOUNT_LEVEL3]}
              />
              {getState()?.resetBtn
                ? <OutlinedButton onClick={() => handleReset()} style={{
                  width: '100px',
                  height: '36.5px'
                }}>buttons.Reset</OutlinedButton>
                : <ContainedButton onClick={() => handleValidate()} style={{
                  width: '100px',
                  height: '36.5px'
                }}>buttons.validate</ContainedButton>}
            </CreateTemplateAccountsIntentContainer>
            <Typography paragraph={true} style={{ fontSize: '16px', color: '#FFF', backgroundColor: '#db4437', width: 'fit-content' }}>{getState()?.errorMsg}</Typography>
          </CardContent>
        </Card>
        <Box component='div' style={{ backgroundColor: '#F3F3F3', width: '100%', height: '1rem', margin: 0, padding: 0 }} />
        {/* </Modal> */}
        {getState()?.showForm &&
          <Card style={{ width: '70vw', margin: '0.5rem' }}>
            <CardContent>
              {/* <HorzintalDivider /> */}
              {/* <div style={{ backgroundColor: '#F3F3F3', width: '100vw', height: '2rem'  }}></div> */}
              <CreateTemplateIntentContainer>
                <Autocomplete
                  id={'createTemplate_templateType'}
                  onChange={onChangeTemplateType}
                  data={data}
                  options={state.templateTypeList}
                  fieldTemplate={formTemplate[SELECT_TEMPLATE_TYPE]}
                  ref={arrRefs[SELECT_TEMPLATE_TYPE]}
                  noTranslateItems
                />
                <Autocomplete
                  id={'createTemplate_templateName'}
                  data={data}
                  options={state.templatesForSelect}
                  fieldTemplate={formTemplate[SELECT_TEMPLATE_NAME]}
                  ref={arrRefs[SELECT_TEMPLATE_NAME]}
                  onChange={onChangeTemplate}
                  noTranslateItems
                />
              </CreateTemplateIntentContainer>
              <OutlinedButton style={{ marginTop: '1rem' }} onClick={handleAddInst}>buttons.addInstructions</OutlinedButton>
            </CardContent>
          </Card>
        }
        {getState().showTable
          ? <Box component='div' style={{ margin: '0.5rem' }}>
            <VerticalDivider />
            <TemplateFormat
              tableRef={tableRef}
              getState={getState}
              setState={setState}
              setSelectedTemplateValues={saveTemplateValues}
              skpEncoding={getState()?.skpEncoding}
              getPageData={getTemplateFields}
              title={title}
              formTemplates={formTemplate}
              arrRefs={arrRefs}
              isEdit={false}
            />
          </Box>
          : null
        }
      </MainRouteSubRoutePage>
    </>
  )
}

export default CreateTemplate
